import { render, staticRenderFns } from "./_tabCategories.vue?vue&type=template&id=72a5c9ed&scoped=true&"
import script from "./_tabCategories.vue?vue&type=script&lang=js&"
export * from "./_tabCategories.vue?vue&type=script&lang=js&"
import style0 from "./_tabCategories.vue?vue&type=style&index=0&id=72a5c9ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a5c9ed",
  null
  
)

export default component.exports